<template>
	<div class="ss-content brilliantEHome-content">
		<div class="brilliantEHome__banner"></div>
		<ss-breadcrumb />
		<div class="ss-container">
			<div class="ss-type-box">
				<div class="ss-type__label">
					<img src="~@/assets/img/brilliantEHome/yc-type.png" width="18px" />
					演出类型
				</div>
				<div class="ss-type__text">
					<span v-for="(item, index) in typeList" @click="changeType(index)" :class="{'active': typeIndex === index}" :key="item.value">{{item.label}}</span>
				</div>
			</div>
			<div class="mt50">
				<ssTrainList :finish="finish_" :busy="busy_" :value="curData_" detailPath="/brilliantEHome/show/" />
				<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
			</div>
		</div>
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components:{
			ssTrainList
		},
		data() {
			return {
				typeList: [{
					value: 'jcycbs,jcyczy,jcyccgzs,jcycdxfy,jcycqt',
					label: '全部'
				}, {
					value: 'jcycbs',
					label: '比赛'
				}, {
					value: 'jcyczy',
					label: '展演'
				}, {
					value: 'jcyccgzs',
					label: '成果展示'
				}, {
					value: 'jcycdxfy',
					label: '大兴非遗'
				}, {
					value: 'jcycqt',
					label: '其他'
				}]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.brilliantEHome-content{
		background-color: #fff;
		padding-bottom: 70px;
		.brilliantEHome-list-box{
			margin-top: 50px;
		}
		.brilliantEHome__banner{
			background: url(~@/assets/img/brilliantEHome/banner.png) center center / 1920px auto no-repeat;
			height: 200px;
		}
	}
</style>
